import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./pages/Login";
import Auth from "./pages/Auth";

import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Jobs from "./pages/Jobs";
import Job from "./pages/Job";
import Session from "./pages/Session";
import Contacts from "./pages/Contacts";
import Contact from "./pages/Contact";
import Accounts from "./pages/Accounts";
import Account from "./pages/Account";
import Locations from "./pages/Locations";
import Tasks from "./pages/Tasks";
import Interactions from "./pages/Interactions";
import SlideManager from "./pages/SlideManager";
import ProgrammeBuilder from "./pages/ProgrammeBuilder";
import CreateHandouts from "./pages/CreateHandouts";
import ELearning from "./pages/ELearning";
import Export from "./pages/Export";
import Settings from "./pages/Settings";
import GlobalTooltips from "./components/GlobalTooltips";

import "./App.css";

const App = () => {
  return (
    <Router>
      {/* Styled hover text for every `title` attribute in the app */}
      <GlobalTooltips />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth" element={<Auth />} />

        {/* Protected routes within Layout */}
        <Route path="/" element={<Layout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="jobs" element={<Jobs />} />
          <Route path="job" element={<Job />} />
          <Route path="session" element={<Session />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="contact" element={<Contact />} />
          <Route path="accounts" element={<Accounts />} />
          <Route path="account" element={<Account />} />
          <Route path="locations" element={<Locations />} />
          <Route path="tasks" element={<Tasks />} />
          <Route path="interactions" element={<Interactions />} />
          <Route path="slides" element={<SlideManager />} />
          <Route path="programmebuilder" element={<ProgrammeBuilder />} />
          <Route path="create-handouts" element={<CreateHandouts />} />
          <Route path="elearning" element={<ELearning />} />
          <Route path="export" element={<Export />} />
          <Route path="settings" element={<Settings />} />
        </Route>

      </Routes>
    </Router>
  );
};

export default App;
